module.exports = __webpack_public_path__ + "static/3-1d08f5b91caecc029da569980a0c52d1.gif";